import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Course } from 'lms-api';
import { ShoppingCartService } from 'lms-api';
import { LmsUserService } from 'lms-api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../login/login.component';
import { UserCourseFeeService } from 'lms-api';

@Component({
  selector: 'app-add-course-to-cart',
  templateUrl: './add-course-to-cart.component.html',
  styleUrls: ['./add-course-to-cart.component.scss']
})
export class AddCourseToCartComponent implements OnInit {
  @Input() course: Course;
  public fee$;

  constructor(public userFeeService: UserCourseFeeService, public cartService: ShoppingCartService, public userService: LmsUserService, public modalService: NgbModal) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.course) {
      this.fee$ = this.userFeeService.GetCourseFee(this.course.netforum_course_id);
    }
  }

  public AddCourseToCart() {
    this.cartService.AddCourse(this.course.netforum_course_id).subscribe();
  }

  public RemoveCourseFromCart() {
    this.cartService.RemoveCourse(this.course.netforum_course_id).subscribe();
  }

  public ShowLoginModal() {
    this.modalService.open(LoginComponent);
  }

}
